import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface Testimonial {
  name: string;
  role: string;
  content: string;
  image: string;
  alt: string;
  rating: number;
}

const TestimonialsSection = () => {
  const testimonials: Testimonial[] = [
  {
    name: "Sarah Mitchell",
    role: "Marketing Professional",
    content: "LivsmartCoach helped me create a sustainable wellness routine that fits my busy schedule. The personalized recommendations are spot-on!",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_116022a91-1763299783599.png",
    alt: "Professional woman with long brown hair smiling warmly in business casual attire",
    rating: 5
  },
  {
    name: "James Chen",
    role: "Software Engineer",
    content: "I love how the AI adapts to my cultural food preferences. Finally, wellness advice that respects my lifestyle and heritage.",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_10d16ebff-1763293698620.png",
    alt: "Asian man with glasses in casual blue shirt smiling confidently",
    rating: 5
  },
  {
    name: "Maria Rodriguez",
    role: "Teacher",
    content: "The conversational approach makes wellness feel approachable, not overwhelming. I've made real progress with the 15-minute routines.",
    image: "https://images.unsplash.com/photo-1694185766501-487b73d10332",
    alt: "Hispanic woman with curly hair in yellow top smiling brightly outdoors",
    rating: 5
  }];


  return (
    <section className="py-16 md:py-24 px-4 bg-surface">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-text-primary mb-4">
            What Our <span className="text-primary">Users Say</span>
          </h2>
          <p className="text-lg text-text-secondary max-w-2xl mx-auto">
            Real stories from people transforming their wellness journey with LivsmartCoach.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {testimonials.map((testimonial, index) =>
          <div
            key={index}
            className="bg-card p-6 md:p-8 rounded-lg border border-border shadow-soft hover:shadow-soft-md transition-smooth">
            
              {/* Rating */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) =>
              <Icon key={i} name="StarIcon" variant="solid" size={20} className="text-accent" />
              )}
              </div>

              {/* Content */}
              <p className="text-text-secondary leading-relaxed mb-6">
                "{testimonial.content}"
              </p>

              {/* User Info */}
              <div className="flex items-center gap-4">
                <div className="relative w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                  <AppImage
                  src={testimonial.image}
                  alt={testimonial.alt}
                  className="object-cover"
                  fill />
                
                </div>
                <div>
                  <h4 className="font-semibold text-card-foreground">
                    {testimonial.name}
                  </h4>
                  <p className="text-sm text-text-secondary">
                    {testimonial.role}
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>);

};

export default TestimonialsSection;